import {
  mapSelectedProfilesValues,
  SocialProfileWithBoardsAndMentionType,
  SocialProfileWithMentionType
} from './mapSelectedProfilesValues';
import { SelectedSocialProfileValue } from '../../../components/socialProfiles/SocialProfileSelectorList/SocialProfileSelectorList.view';
import { GroupPostAttributesType } from '../../../models/post-editor';
import { ActiveCustomizeIndexType } from '../states/ActiveCustomizeIndexProvider';

export const getSelectedProfilesWithBoards = (
  selectedProfiles: SelectedSocialProfileValue[],
  availableProfiles: SocialProfileWithMentionType[],
  customizeIndex: ActiveCustomizeIndexType,
  customize: boolean,
  posts: GroupPostAttributesType[]
): SocialProfileWithBoardsAndMentionType[] => {
  const selectedProfilesValues =
    typeof customizeIndex === 'number' && customize
      ? selectedProfiles.find(profile => profile.profileId === posts[customizeIndex].customizedProfileId)
      : selectedProfiles;
  const mappedSelectedProfiles = Array.isArray(selectedProfilesValues)
    ? selectedProfilesValues
    : selectedProfilesValues
    ? [selectedProfilesValues]
    : [];
  return mapSelectedProfilesValues(mappedSelectedProfiles, availableProfiles);
};
